import { useTranslation } from 'react-i18next';
import { UnsavedChangesProtection } from 'v5/patterns/forms/unsaved-changes/UnsavedChangesProtection';
import { Dialog, DialogContentHeadless } from 'v5/design-system/Dialog';
import { MountElementProps } from 'v5/messages/mount-element';
import { WithServices } from 'v5/platform/ts/services';
import { WithFormatService } from 'cockpit/services/format/FormatService';
import { WithToastService } from 'v5/services/front/ToastService/ToastService';
import { WithAppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService';
import { WithSystemSettingsService } from 'v5/services/internal/SystemSettingsService/SystemSettingsService';
import { WithAvailabilityRequestService } from 'v5/services/io/AvailabilityRequestService/AvailabilityRequestService';
import { WithResourceMutationService } from 'v5/services/io/ResourceMutationService/ResourceMutationService';
import { WithResourceService } from 'v5/services/io/ResourceService/ResourceService';
import { RequestAvailabilityDialogContent } from './RequestAvailabilityDialogContent';

export interface RequestAvailabilityDialogProps
  extends WithServices<
    [
      WithAvailabilityRequestService,
      WithResourceService,
      WithResourceMutationService,
      WithFormatService,
      WithToastService,
      WithAppScopeService,
      WithSystemSettingsService
    ]
  > {
  resourceIds: number[];
}

export function RequestAvailabilityDialog({
  open,
  onOpenChange,
  resourceIds,
  services
}: RequestAvailabilityDialogProps & MountElementProps) {
  const { t } = useTranslation('availability-request', {
    keyPrefix: 'RequestAvailabilityDialog'
  });

  return (
    <UnsavedChangesProtection
      open={open}
      onOpenChange={onOpenChange}
      beforeUnloadMessage={t('unsavedChangesBeforeUnload')}
    >
      {dialogProps => (
        <Dialog {...dialogProps}>
          <DialogContentHeadless>
            <RequestAvailabilityDialogContent
              open={dialogProps.open}
              resourceIds={resourceIds}
              onClose={() => onOpenChange(false)}
              services={services}
            />
          </DialogContentHeadless>
        </Dialog>
      )}
    </UnsavedChangesProtection>
  );
}
